import { Routes, Route, Navigate } from "react-router-dom";
import Header from "components/headers/Header";
import Home from "./components/home/Home";
import ReportTabs from "components/home/ReportTabs";
//import Report from "./components/report/Report";
import { getStateLoaded } from "store/store";
import Footer from "components/headers/Footer";

export default function App() {
  var loaded = getStateLoaded();
  console.log("App loaded: ", loaded);
  return (
    <div className="main">
      <Header />
      <div id='top' className="top-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          {/* <Route exact path="/report" element={  loaded ? (<Report />) : (<Navigate replace to={"/"} />)} /> */}
          <Route path="/reports" element={<ReportTabs />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

